import React, { FC, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from "chart.js";
import { Line } from "react-chartjs-2";
import { useAppSelector } from "../../store/hooks";
import { selectData } from "../../store/chart/chartSlice";
import { ChartData, ChartZoom } from "../../store/chart/types";
import { RootState } from "../../store";
import { connect, ConnectedProps } from "react-redux";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const mapState = (state: RootState) => ({
  chartZoom: state.chart.chartZoom,
  data: state.chart.data,
  dayData: state.chart.dayData
});

const mapDispatch = {
  setData: () => ({ data: {} as ChartData }),
  setDayData: () => ({ dayData: {} as ChartData }),
  setChartZoom: () => ({ chartZoom: {} as ChartZoom }),
};

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & { data: ChartData, dayData: ChartData, chartZoom: ChartZoom };

const WorthLine: FC<Props> = (props: Props) => {
  let displayedData: number[] = [];
  let displayedLabels: string[] = [];
  if(props.chartZoom.worthLine === "day") {
    displayedData = props.dayData.dayValues;
    displayedLabels = props.dayData.dayDates;
  } else if (props.chartZoom.worthLine === "week") {
    displayedData = props.data.weekValues;
    displayedLabels = props.data.weekDates;
  } else if (props.chartZoom.worthLine === "month") {
    displayedData = props.data.monthValues;
    displayedLabels = props.data.monthDates;
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top" as const,
        labels: { color: "#FFFFFF" },
        display: false,
      },
      interaction: {
        mode: 'index',
        intersect: false
      },
      title: {
        display: false,
        text: "Asset Worth",
        color: "#FFFFFF",
        position: "top",
        align: "start",
        padding: 10,
        font: {
          family: "'Poppins', sans-serif",
          size: 17, 
          weight: '400'
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#FFFFFF",
          font: {
            family: "'Roboto', sans-serif",
            size: 10
          },
        },
        grid: {
          color: "rgb(255, 255, 255, 0.1)",
        },
      },
      y: {
        ticks: {
          color: "#FFFFFF",
          font: {
            family: "'Roboto', sans-serif",
            size: 10
          },
        },
        grid: {
          color: "rgb(255, 255, 255, 0.1)",
        },
      },
    },
  };

  const labels = displayedLabels;

  const data = {
    labels,
    datasets: [
      {
        label: "Total worth", // label at top of chart
        data: displayedData, // actual data points
        borderColor: "rgba(0, 140, 236, 1)", // color of the line
        backgroundColor: "rgba(0, 140, 236, 0.3)",
        pointBackgroundColor: "rgba(255, 255, 255, 1)", // fill color of label
        pointRadius: 4,
        fill: true,
        tension: 0.2,
        //cubicInterpolationMode: "monotone",
      },
    ],
  };

  useEffect(() => {

  }, [props])

  return (
    <div className="w-full h-1/2">
      {/* @ts-ignore */}
      <Line options={options} data={data} />
    </div>
  );
};

export default connector(WorthLine);
